export default __webpack_public_path__ + "static/media/telcos_red.a6f1cfee.svg";